import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "layer deletAlt" }
const _hoisted_2 = { class: "layerBtnArea" }
const _hoisted_3 = {
  key: 0,
  class: "loading"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "layerTitle" }, "알림", -1)),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "layerMain" }, [
        _createElementVNode("div", { class: "layerMainText" }, [
          _createTextVNode(" 본인인증이 완료되지 않았습니다. "),
          _createElementVNode("br"),
          _createElementVNode("span", { class: "bold" }, "서비스 이용이 제한될 수 있으니 지금 인증을 완료"),
          _createTextVNode("해 주세요. ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "blueBtn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.request && $options.request(...args)))
        }, "지금 인증하기")
      ])
    ], 512), [
      [_vShow, $data.visible]
    ]),
    ($data.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("div", { class: "spinner" }, null, -1)
        ]))]))
      : _createCommentVNode("", true)
  ], 64))
}